export default (theme) => {
  return `
  .mu-snackbar {
    color: ${theme.text.alternate};
    background-color: ${theme.text.primary};
  }
  `;
};



// WEBPACK FOOTER //
// ./src/muse-ui/Snackbar/theme.js